import React from 'react'

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

import logoSvg from './logo.svg'
import { rhythm } from '../utils/typography'

class Bio extends React.Component {
  render() {
    return (
      <p
        className="bio"
        style={{
          marginBottom: rhythm(2.5),
        }}
      >
        Written by the <strong>Intelligent Routing team</strong> who work hard to make vehicle route optimization
        software available to every business that runs a fleet. <br />
        <a href="https://twitter.com/IntelligntRoute">You should follow them on Twitter</a>
      </p>
    )
  }
}

export default Bio



// WEBPACK FOOTER //
// ./src/components/Bio.js